module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Bold-d4821d27c1de3fea520ff2ce0b58b806.ttf";